import { AkinatorCompletion } from 'types/suggestions';

export const getUpdatedQueryByCompletionType = (query: string, completion: AkinatorCompletion): string => {
  const wordsArray = query.trim().split(/\s+/);

  if (completion.type === 'CONTINUE') {
    return [...wordsArray, completion.name].join(' ');
  } else {
    return [completion.name].join(' ');
  }
};
